import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Fourimg from '../../../assets/images/portfolio/Aerrow-right.svg'
import Four1 from '../../../assets/images/portfolio/portfolio-four-1.jpg'
import Four2 from '../../../assets/images/portfolio/portfolio-four-2.jpg'
import Four3 from '../../../assets/images/portfolio/portfolio-four-3.jpg'
import Four4 from '../../../assets/images/portfolio/portfolio-four-4.jpg'


const PortfolioSectionFour = () => {
    const [backgroundImage, setBackgroundImage] = useState(Four1);
    const [activeIndex, setActiveIndex] = useState(0);

    const portfolioItems = [
        {
            id: 1,
            image: Four1,
            title: 'Minimal Design',
            description: 'Success',
        },
        {
            id: 2,
            image: Four2,
            title: 'Innovator',
            description: 'Success',
        },
        {
            id: 3,
            image: Four3,
            title: 'Marketing Expert',
            description: 'Success',
        },
        {
            id: 4,
            image: Four4,
            title: 'Marketing',
            description: 'Success',
        },
    ];

    return (
        <div className="portfolio-section-four">
            <div className="container-fluid p-0">
                <div className="portfolio-four">
                    <div
                        className="portfolio-background"
                        style={{ backgroundImage: `url(${backgroundImage})` }}
                    ></div>
                    {portfolioItems.map((item, index) => (
                        <div
                            key={item.id}
                            className={`portfolio-box-four ${activeIndex === index ? 'active' : ''}`} // Add active class
                            onMouseEnter={() => {
                                setBackgroundImage(item.image);
                                setActiveIndex(index); // Set active index on hover
                            }}
                            onMouseLeave={() => {
                                setBackgroundImage(portfolioItems[activeIndex].image); // Reset to the active item image
                            }}
                        >
                            <div className="portfolio-image-four">
                                <img src={item.image} alt="portfolio-image" />
                            </div>
                            <div className="portfolio-details-four">
                                <span className="tagline">Portfolio</span>
                                <Link to="/Details" className="portfolio-btn-four">
                                    <img src={Fourimg} alt="icon" />
                                </Link>
                                <h4>
                                    <Link to="/Details">{item.title}</Link>
                                </h4>
                                <p>{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PortfolioSectionFour;